import { LocalDate } from '../../../../pojo/date-variable';

export class MaHorNavData {
  reported = new MaPeriods();
  vintage = new MaVintageSelectors();
}

export class MaVintageSelectors {
  initial: LocalDate[];
  from = new MaPeriods();
  till = new MaPeriods();
}

export class MaPeriods {
  selected: LocalDate;
  periods: LocalDate[];
}

export enum MaSelector {
  REPORTED_PERIODS = 'reported-periods',
  FROM = 'from',
  TILL = 'till'
}

